//ng build --configuration release
export const environment = {
  production: false,
  nhwsApiEndPoint: '__nhwsApiEndPoint__',
  censusLiteApiEndpoint: '__censusLiteApiEndpoint__',
  planLiteApiEndpoint: '__planLiteApiEndpoint__',
  quoteLiteApiEndpoint: '__quoteLiteApiEndpoint__',
  authEndPoint: '__authEndPoint__',
  userApiEndPoint: '__userApiEndPoint__',
  nqsPlanApiEndPoint: '__nqsPlanApiEndPoint__',
  nqsQuoteApiEndPoint: '__nqsQuoteApiEndPoint__',
  redirectUri: '__redirectUri2__',
  wbQuoteUrl: '__wbQuoteUrl__',
  quoteLiteUrl: '__quoteLiteUrl__',
  medIdApiUri: '__medIdApiUri__',
  idleTime: 3000,
  idleTimeout: 10,
  ApplicationInsightsInstrumentationKey:
    '__ApplicationInsightsInstrumentationKey__',
  DisableApplicationInsights: '__DisableApplicationInsights__',
  carrierLogosUrl: '__carrierLogosUrl__',
  cspObjectSrc: '__cspObjectSrc__',
  cspConnectSrc: '__cspConnectSrc__',
  cspFontSrc: '__cspFontSrc__',
  cspFrameSrc: '__cspFrameSrc__',
  cspImgSrc: '__cspImgSrc__',
  cspWorkerSrc: '__cspWorkerSrc__',
  cspMediaSrc: '__cspMediaSrc__',
  cspScriptSrc: '__cspScriptSrc__',
  cspStyleSrc: '__cspStyleSrc__',
  cspRequireTrustedTypesFor: '__cspRequireTrustedTypesFor__',
  enableCSP: '__enableCSP__',
  AuthRequireHttps: '__AuthRequireHttps__',
  SingleSignoutRedirect: '__SingleSignoutRedirect__',
  AuthSessionChecksEnabled: '__AuthSessionChecksEnabled__',
  UseNqsQuoteApiContribution: '__UseNqsQuoteApiContribution__',
};
